<template>
  <div>
    <v-container grid-list-xs pt-0>
      <v-layout>
        <v-flex lg12>
          <v-flex lg8 offset-lg2 v-if="externalRequestInspection">
            <RequestInspectionCard :requestInspection="externalRequestInspection"></RequestInspectionCard>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import RequestInspectionCard from "./RequestInspectionCard";
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";

export default {
  computed: {
    ...mapGetters(["externalRequestInspection", "loadingExternal","agency"])
  },
  mounted() {
    this.$store.dispatch("external");
  },
  components: {
    RequestInspectionCard
  },
  watch: {
    loadingExternal(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando configuración");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val){
      this.$store.dispatch("external");
    }
  },
  data() {
    return {};
  }
};
</script>